import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../css/Signup.css";

function Signup() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [password_confirm, setPassword_confirm] = useState("");
  const [email, setEmail] = useState("");
  const [phone_number, setPhone_number] = useState("");
  const [name, setName] = useState("");
  const [nickname, setNickname] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [error, setError] = useState("");
  const [codeSent, setCodeSent] = useState(false); // 인증번호 전송 여부

  // 전화번호 인증번호 전송
  const sendVerificationCode = async () => {
    try {
      const response = await axios.post(
        "http://35.192.131.111/user/send/code/",
        {
          phone_number,
        }
      );

      if (response.data.result) {
        setCodeSent(true);
        alert("인증번호가 전송되었습니다.");
      }
    } catch (error) {
      setError("인증번호 전송에 실패했습니다.");
    }
  };

  // 인증번호 확인
  const verifyCode = async () => {
    try {
      const response = await axios.post(
        "http://35.192.131.111/user/verify/code/",
        {
          phone_number,
          verification_code: Number(verificationCode), // 인증번호를 숫자로 변환하여 전송
        }
      );

      if (response.data.result) {
        alert("인증이 완료되었습니다.");
      } else {
        setError("인증번호가 올바르지 않습니다.");
      }
    } catch (error) {
      setError("인증번호 확인에 실패했습니다.");
    }
  };

  const handleCancel = () => {
    alert("회원가입이 완료되었습니다.");
    navigate("/");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // 비밀번호와 비밀번호 확인 일치 여부 확인
    if (password !== password_confirm) {
      setError("비밀번호가 일치하지 않습니다.");
      return;
    }

    try {
      const response = await axios.post(
        "http://35.192.131.111/user/register/",
        {
          name,
          username,
          password,
          password_confirm,
          nickname,
          phone_number,
          email,
        }
      );

      if (response.status === 201) {
        navigate("/");
      }
    } catch (error) {
      setError("회원가입에 실패했습니다. 다시 시도해주세요.");
    }
  };

  return (
    <div className="signup-Main">
      <div className="signup-container">
        <h2>회원가입</h2>
        <form className="signup-form" onSubmit={handleSubmit}>
          <TextField
            label="이름"
            placeholder="이름을 입력해주세요."
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            label="아이디"
            placeholder="아이디를 입력해주세요."
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            label="비밀번호"
            type="password"
            placeholder="비밀번호를 입력해주세요."
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <TextField
            label="비밀번호 확인"
            type="password"
            placeholder="비밀번호를 재입력해주세요."
            value={password_confirm}
            onChange={(e) => setPassword_confirm(e.target.value)}
          />
          <TextField
            label="이메일"
            placeholder="이메일을 입력해주세요."
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          {/* 전화번호 인증 */}
          <div className="phone-verification">
            <TextField
              label="전화번호"
              placeholder="전화번호를 입력해주세요."
              value={phone_number}
              onChange={(e) => setPhone_number(e.target.value)}
            />
            <button type="button" onClick={sendVerificationCode}>
              인증요청
            </button>
          </div>

          {codeSent && (
            <div className="verification-code">
              <TextField
                label="인증번호"
                placeholder="인증번호를 입력해주세요."
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
              />
              <button type="button" onClick={verifyCode}>
                인증 확인
              </button>
            </div>
          )}

          <TextField
            label="닉네임"
            placeholder="닉네임을 입력해주세요."
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
          />
          {error && <p className="error">{error}</p>}
          <div className="button-Sign">
            <button
              type="button"
              className="Signup-Button Cancellation"
              onClick={handleCancel}
            >
              취소
            </button>
            <button type="submit" className="Signup-Button Registration">
              등록
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// TextField 컴포넌트
const TextField = ({ label, placeholder, value, onChange, type = "text" }) => (
  <div className="form-group">
    <div className="group-Name">{label}</div>
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  </div>
);

export default Signup;
